<mat-card *ngIf="itinerary">
  <form fxLayout="column" name="itinerary-info-form">
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Destinazione</mat-label>
        <input
          name="destination"
          matInput
          [(ngModel)]="itinerary.destination"
          type="text"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Numero persone</mat-label>
        <input
          name="npax"
          matInput
          [(ngModel)]="itinerary.npax"
          type="number"
          min="1"
          step="1"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" style="cursor: pointer">
        <mat-label>Dal</mat-label>
        <input
          name="start"
          matInput
          readonly
          [disabled]="startEndDatesLocked"
          [matDatepicker]="pickerStart"
          [(ngModel)]="itinerary.start"
          (ngModelChange)="onStartEndChange()"
          (click)="pickerStart.open()"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerStart"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" style="cursor: pointer">
        <mat-label>Al</mat-label>
        <input
          matInput
          name="end"
          readonly
          [disabled]="startEndDatesLocked"
          [matDatepicker]="pickerEnd"
          [(ngModel)]="itinerary.end"
          (ngModelChange)="onStartEndChange()"
          (click)="pickerEnd.open()"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <span
        fxLayout="column"
        fxLayoutAlign="center center"
        *ngIf="
          { start: itinerary.start?.toDate(), end: itinerary.end?.toDate() }
            | daysBetween;
          let nDays
        "
        ><span *ngIf="nDays >= 0"
          >{{ nDays }} giorni ({{ nDays - 1 }} notti)</span
        ><button
          *ngIf="
            startEndDatesLocked &&
            !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
          "
          mat-button
          type="button"
          class="btn-modifica-date"
          mat-raised-button
          (click)="unlockStartEndDates()"
        >
          Modifica Date
        </button></span
      >
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Titolo itinerario</mat-label>
      <input
        name="title"
        matInput
        [(ngModel)]="itinerary.title"
        type="text"
        required
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Descrizione Destinazione</mat-label>
      <textarea
        rows="5"
        name="description"
        matInput
        [(ngModel)]="itinerary.description"
        required
      ></textarea>
      <app-inline-help-button
        matSuffix
        [title]="'Descrizione Destinazione'"
        [content]="
          'Scrivi qualcosa che introduca il cliente alla destinazione e alle sue meraviglie! Trasmetti il tuo amore per la meta. Usa questo spazio per dare informazioni di carattere generico (prese per la corrente, moneta/valuta, religione, usanze, cibi/bevande da provare, consigli extra, ecc, ecc). Se lo spazio non dovesse bastarti puoi utilizzare le “informazioni aggiuntive”.\n\nAttenzione a non eccedere lo spazio disponibile nell’itinerario, utilizza la funzione “Anteprima” per controllare.'
        "
      >
      </app-inline-help-button>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Informazioni aggiuntive</mat-label>
      <textarea
        rows="5"
        name="additionalInfo"
        matInput
        [(ngModel)]="itinerary.additionalInfo"
      ></textarea>
      <app-inline-help-button
        matSuffix
        [title]="'Informazioni aggiuntive'"
        [content]="
          'Attenzione a non eccedere lo spazio disponibile nell’itinerario, utilizza la funzione “Anteprima” per controllare.'
        "
      >
      </app-inline-help-button>
    </mat-form-field>

    <span>&nbsp;&nbsp;</span>

    <div fxLayout="row">
      <app-itinerary-image-form-field
        [(image)]="itinerary.coverImage"
        [itineraryId]="itinerary.id"
        [label]="'Foto copertina 1 *'"
        [disabled]="
          itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
        "
      ></app-itinerary-image-form-field>

      <span>&nbsp;&nbsp;</span>
      <span>&nbsp;&nbsp;</span>

      <app-itinerary-image-form-field
        [(image)]="itinerary.secondaryImage"
        [itineraryId]="itinerary.id"
        [label]="'Foto copertina 2 *'"
        [disabled]="
          itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
        "
      ></app-itinerary-image-form-field>
    </div>
  </form>
</mat-card>
